<template>
  <div class="vr contentarea">
    <slick 
      ref="slick"
      :options="slickOptions">
      <div v-for="(vr, index) in data" class="iframe_wrapper">
        <p class="rb">{{vr.ruby}}</p>
        <p class="rb_title">{{vr.title}}</p>
        <div class="vr_label">(VR)</div>
        <iframe :src="vr.url" scrolling="no"></iframe>
        <p class="txt">{{vr.text}}</p>
      </div>
    </slick>
  </div>
</template>

<style lang="less">
  //mediaquery設定
  @screen-xs-max: 660px; //スマホ
  @screen-sm-max: 768px; //ipad
  @screen-lg-max: 1200px; //ブラウザサイズ1200px以下
  .screen-xs(@rules) {
      @media (max-width: @screen-xs-max) { @rules(); } 
  }
  .screen-sm(@rules) {
      @media (max-width: @screen-sm-max) { @rules(); }
  }
  .screen-lg(@rules) {
      @media (max-width: @screen-lg-max) { @rules(); }
  }

  @import '../../node_modules/slick-carousel/slick/slick.css';

  .vr {
    .rb{
      font-size: 20px;
      letter-spacing: 5px;
      .screen-xs({
        font-size: 16px;
        letter-spacing: 3px;
      });
    }
    .rb_title{
      font-size: 38px;
      .screen-xs({
        font-size: 28px;
      });
    }
    .slick-arrow{
      position: absolute;
      top: 50%;
      z-index: 100;
      padding: 4px 8px;
      background: none;
      border: none;
      cursor: pointer;
      outline: none;
    }
    .slick-prev{
      left: 10px;
      .slide_txt{
        color: #BFBFBF;
        font-size: 18px;
      }
      .screen-xs({
        left: 0;
        img{
          width: 70%;
        }
      });
    }
    .slick-next{
      right: 10px;
      .slide_txt{
        color: #BFBFBF;
        font-size: 18px;
      }
      .screen-xs({
        right: 0;
        img{
          width: 70%;
        }
      });
    }
    .slick-slide{
      h4 {
        margin-bottom: 10px;
        ruby {
          font-size: 38px;
          .screen-xs({
            font-size: 28px;
          });
        }
      }
      .vr_label {
        margin: 0 auto;
        width: 60px;
        height: 30px;
        background: #3F698F;
        color: #FFF;
        font-size: 21px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      iframe {
        position: relative;
        margin: 10px 0;
        width: 100%;
        // height: 700px;
        top: 0;
        left: 0;
        border: none;
      }
      .txt{
        margin-bottom: 100px;
        font-size: 16px;
        text-align: left;
        .screen-sm({
          margin-bottom: 20px;
        });
      }
    }
    .row{
      margin: 0 auto 50px;
      padding: 10px 0;
      width: 80%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #000;
      .screen-sm({
        width: 99%;
      });
      .screen-xs({
        display: none;
      });
      .colmn{
        .help_img{
          width: 50px;
          margin: 0 auto;
        }
        .help_txt{
          font-size: 14px;
        }
        .w-70{
          width: 70px;
        }
      }
      .px-10{
        padding-right: 5%;
        padding-left: 5%;
        .screen-sm({
          padding-right: 2%;
          padding-left: 2%;
        });
      }
    }
  }
  #container{
    margin: 0 auto;
  }
</style>

<script>
  import Slick from "vue-slick"
  import $ from "jquery"

  export default {
    name: 'Vr',
    props: {
      data:Array
    },
    components: {Slick},
    data() {
      const self = this
      return {
        slickOptions: {
          infinite: false,
          /*
          dots: true,
          // スライド下のサムネイル表示
          customPaging: function(slider, i) {
            const thumbSrc = self.data[i].thumbnail
            return '<img src="' + thumbSrc + '">'
          }
          */
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="image/prev.png" alt="Previous"><p class="slide_txt">Prev</p></button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><img src="image/next.png" alt="Next"><p class="slide_txt">Next</p></button>',
        }
      }
    },
    mounted(){
      //iframe要素の幅と高さ調整
      $('iframe').on('load', function(){
        var iframe_width = parseFloat($('iframe').contents().find('#container').css('width')); //iframeの幅取得
        var iframe_height = parseFloat($('iframe').contents().find('#container').css('height')); //iframeの高さ取得
        var content_width = $('.iframe_wrapper').width(); //表示領域の幅取得
        var this_width = ""; //幅設定用
        var this_height = ""; //高さ設定用

        function setting(){
          var myDefer = $.Deferred(); // deferオブジェクト生成
          
          if( iframe_width < content_width ){
            //iframeの幅と高さをそのまま表示領域の高さにする
            this_width = iframe_width + 20 +'px'; //微妙に見切れるため20px分追加
            this_height = iframe_height + 20 +'px'; //微妙に見切れるため20px分追加
            $('iframe').contents().find('#container').css('width', iframe_width + 'px'); //iframeの幅を表示領域に合わせる
            $('iframe').contents().find('#container').css('height', iframe_height + 'px'); //iframeの高さを表示領域に合わせる
            myDefer.resolve();
          }else{
            //iframeのほうが大きい場合
            this_width = content_width + 'px';
            this_height = (iframe_height * (content_width / iframe_width)) + 20 + 'px'; //微妙に見切れるため20px分追加
            $('iframe').contents().find('#container').css('width', (content_width - 20) + 'px'); //iframeの幅を表示領域に合わせる
            $('iframe').contents().find('#container').css('height', ((iframe_height * (content_width / iframe_width)) - 20) + 'px'); //iframeの高さを表示領域に合わせる
            myDefer.resolve();
          }

          return  myDefer.promise();
        }

        setting().then(
          function(){
            $('iframe').css("width", this_width);
            $('iframe').css("height", this_height);
          }
        );
      });
    },
    beforeUpdate() {
      // slick適用後はデータ更新がうまくいかないので更新前に解除
      if (this.$refs.slick) {
        this.$refs.slick.destroy()
      }
    },
    updated() {
      this.reInit()
    },
    methods: {
      reInit() {
        // データ更新後にslick適用
        this.$nextTick(() => {
          this.$refs.slick.create()
        });
      }
    }
  }
</script>